module.exports = __webpack_public_path__ + "static/media/nimes_tour_tn.1a3277f4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Provence/nimes_tour_tn.jpg
// module id = 740
// module chunks = 0